// libraries.
import { useSelector } from 'react-redux';

// slices.
import { getIsHoveredSidebar } from '@shared/Sidebar/store/slices/sidebar-slice';

// shared.
import { ButtonLogo, Sidebar } from '@shared';
import { DropdownCountry } from '@domains/user/components/DropdownCountry/DropdownCountry';
import { LogOutButton } from '@domains/user/components/LogOutButton/LogOutButton';
import { ButtonDocumentsViewer } from './components/ButtonDocumentsViewer';
import { ButtonDocumentsTasks } from './components/ButtonDocumentsTasks';
import { ButtonReassignTasks } from './components/ButtonReassignTasks';
import { ButtonGeoreferencing } from './components/ButtonGeoreferencing';

export const SidebarDocuments = () => {
  const isHoveredSidebar = useSelector(getIsHoveredSidebar);

  return (
    <Sidebar
      upperButtons={
        <>
          <ButtonLogo />
          <ButtonDocumentsTasks />
          <ButtonDocumentsViewer />
          <ButtonReassignTasks />
          <ButtonGeoreferencing />
        </>
      }
      lowerButtons={
        <>
          <DropdownCountry isHoveredSidebar={isHoveredSidebar} />
          <LogOutButton />
        </>
      }
    />
  );
};
